import { Route, Router, Switch } from 'react-router-dom';

import * as K from 'common/constants';
import { DEFAULT_THEME } from 'service/browser';
import history from 'service/customHistory';
import TryScalyrForm from 'components/standalonePages/TryScalyrForm';
import SignUpForm from 'components/standalonePages/SignUpForm';
import { AvailableTheme } from 'common/types';
import { setUITheme } from 'service/browser';
import { getUrlParam } from 'common/functions';

export function verifyIsStandalonePage(location: Location): boolean {
  const route = location.pathname as K.ROUTE;
  const standaloneRoutes = [K.ROUTE.TRY_SCALYR_FORM, K.ROUTE.SIGN_UP_FORM];

  return standaloneRoutes.includes(route);
}

function StandaloneReactPages(): JSX.Element {
  const urlTheme = getUrlParam(window?.location?.search || '', K.URL_PARAM.THEME) as unknown as AvailableTheme;

  if (urlTheme && Object.values(AvailableTheme).includes(urlTheme)) {
    setUITheme(urlTheme);
  } else {
    setUITheme(DEFAULT_THEME);
  }

  return (
    <Router history={history}>
      <Switch>
        <Route path={K.ROUTE.TRY_SCALYR_FORM} component={TryScalyrForm} />
        <Route path={K.ROUTE.SIGN_UP_FORM} component={SignUpForm} />
      </Switch>
    </Router>
  );
}

export default StandaloneReactPages;
